import Api from '@/api/Api'
import store from '../store'

export default {

  async getBusinessType () {
    return store.dispatch('checkResponseApi', await Api().get('analytics/business-type'))
  },

  async getBusinessCategory () {
    return store.dispatch('checkResponseApi', await Api().get('analytics/business-category'))
  },

  async getActiveUsers () {
    return store.dispatch('checkResponseApi', await Api().get('analytics/active-users'))
  },

  async getShopDailySale (shopId) {
    return store.dispatch('checkResponseApi', await Api().get(`analytics/shop-daily-sale?shop_id=${shopId}`))
  },

  async getShopAvgProductPrice () {
    return store.dispatch('checkResponseApi', await Api().get('analytics/shops-avg-product-price'))
  },

  async getTrendApp () {
    return store.dispatch('checkResponseApi', await Api().get('analytics/trend-app'))
  },

  async getTrendAppModule (appId) {
    return store.dispatch('checkResponseApi', await Api().get(`analytics/trend-app-module?app_id=${appId}`))
  },

}



// WEBPACK FOOTER //
// ./src/api/AnalyticService.js